import React, { useState, useRef, useEffect } from "react";
import { defaultPaymentAccount, InvoiceData, PaymentAccount } from "../../../../dto/profiledata/ProfileDataFormDTO";
import { Combobox, EInputTypes, ETypeOfNotification, InputDate, InputSwitch, InputTextCustom, Modal, setNotification, TextArea, CustomStepsRef, CustomSteps} from "medere-ui-framework";
import { getAllAdministrativeFormTypes, getPaymentMethods, getPaymentMethodsForCombo, getVatCustomerCategories, loadAllPOS } from "../../../../services/SupplierController";
import { generateAfipPrivateKey, generateCSRCertificate, getCurrentAfipStep, loadDocumentTypes, saveAfipCertificate, testAfipConnection } from "../../../../services/ProfileDataFormController";
import { Checkbox } from "primereact/checkbox";
import { ComboDataDTO } from "../../../../dto/ComboDataDTO";
import { Icon } from "@iconify/react";
import { classNames } from "primereact/utils";
import { useDispatch } from "react-redux";
import ResetAfipConnectionModal from "./modal/ResetAfipConnectionModal";
import PaymentAccountModalModal from "./modal/PaymentAccountModal";
import PaymentAccountModal from "./modal/PaymentAccountModal";
import { current } from "@reduxjs/toolkit";

interface InvoiceTabProps {
    invoiceData:InvoiceData
    setInvoiceData: (invoiceData:InvoiceData) => void
}

export default function InvoiceTab({invoiceData, setInvoiceData}:InvoiceTabProps) {

    const dispatch = useDispatch();

    const [provisoryFiscalId, setProvisoryFiscalId] = useState(invoiceData.fiscalid);
    const [provisoryAfipAlias, setProvisoryAfipAlias] = useState(invoiceData.afipalias);

    const [openResetAfipConnectionModal, setOpenResetAfipConnectionModal] = useState(false);
    const [openPaymentAccountModal, setOpenPaymentAccountModal] = useState(false);

    const [editPaymentAccount, setEditPaymentAccount] = useState(false);
    const [selectedPaymentAccount, setSelectedPaymentAccount] = useState<PaymentAccount>(defaultPaymentAccount);
    const stepsRef = useRef<CustomStepsRef>(null);

    const [isAfipConnectionTestingLoading, setIsAfipConnectionTestingLoading] = useState(false)
    const [isAfipConnectionSuccessful, setIsAfipConnectionSuccessful] = useState<boolean | null>(null)
    const [dfCertificateDue, setDfCertificateDue] = useState<Date>(null);
    const [afipCertificate, setAfipCertificate] = useState<string>('');

    useEffect(() => {
        getCurrentAfipStep().then((response) => {
            if(response) {
                stepsRef.current.setActiveStep(response);
            }
        }); 
    }, []);

    const handleAddOrEditionPaymentAccount = (isEditing: boolean, accountToEdit: PaymentAccount) => {
        
        let currentAccounts:PaymentAccount[] = invoiceData.paymentaccounts || [];

        // Si estoy editando, borro la que había
        if(isEditing) {
            console.log("editando")
            if(selectedPaymentAccount.paymentaccount == null) {
                currentAccounts = currentAccounts.filter(acc => acc !== selectedPaymentAccount);
                console.log("Cuenta nueva, currentAccounts: ", currentAccounts);
            } else {
                console.log("Cuenta editada, currentAccounts: ", currentAccounts);
                currentAccounts = currentAccounts.filter(account => account.paymentaccount !== accountToEdit.paymentaccount);
            }
        }

        // Agrego la nueva cuenta de pago
        currentAccounts.push(accountToEdit);
        console.log("Agregando cuenta, currentAccounts: ", currentAccounts);
        
        setInvoiceData({...invoiceData, paymentaccounts: currentAccounts});
    };

    const handleDeletePaymentAccount = (account: PaymentAccount) => {
        // Filtrar para eliminar la cuenta seleccionada
        const updatedAccounts = invoiceData.paymentaccounts.filter(
            item => item.accountId !== account.accountId
        );
    
        // Actualizar el estado
        setInvoiceData({
            ...invoiceData,
            paymentaccounts: updatedAccounts
        });
    };

    return <React.Fragment>
        <div className="grid-container ">
            <div className="grid-row four-columns">
                <Combobox 
                    label='Condición de IVA' 
                    placeholder='Seleccionar' 
                    autocompleteClassName="combobox-border"  
                    getItems={getVatCustomerCategories}
                    optionLabel='categoryname'
                    value={invoiceData.vatcustomercategory?.name}
                   
                    setValue={(vatCustomerCategory: any) => setInvoiceData({ ...invoiceData, vatcustomercategory: {id: vatCustomerCategory.vatcustomercategory, name: vatCustomerCategory.categoryname} })}
                />
                <Combobox
                    label='Tipo de documento'
                    placeholder='Seleccionar'
                    autocompleteClassName="combobox-border"
                    getItems={loadDocumentTypes}
                    optionLabel='shortName'
                    value={invoiceData.fiscalidtype?.name ?? ""}
                    setValue={(documentType: any) => setInvoiceData({ ...invoiceData, fiscalidtype: {id: documentType.documentType, name: documentType.shortName} })}
                />
                <InputTextCustom
                    className={'white-component'} 
                    spanClassName="border2"
                    
                    name="document"
                    value={invoiceData.fiscalid ?? ""}
                    onChange={(e) => {
                        setProvisoryFiscalId(e.target.value);
                        if(stepsRef.current.getActiveStep() == 0) {
                            setInvoiceData({...invoiceData, fiscalid: e.target.value});
                            return;
                        }
                        setOpenResetAfipConnectionModal(true);
                    }}
                    label='N° de documento fiscal'
                />
                <InputTextCustom
                    className="white-component"
                    spanClassName='border2'
                    name="razonSocial"
                    value={invoiceData.businessname ?? ""}
                    onChange={(e) => setInvoiceData({ ...invoiceData, businessname: e.target.value })}
                    label='Razón social'
                />
            </div>
            <div className="grid-row iibb-row">
                <InputTextCustom
                    className="white-component"
                    spanClassName='border2'
                    name="iibbPercentage"
                    value={invoiceData.iibb ?? ""}
                    onChange={(e) => setInvoiceData({ ...invoiceData, iibb: e.target.value })}
                    label="IIBB % de percepción"
                />
                <div className="checkbox-item" style={{marginTop: '35px'}}>
                    <Checkbox inputId="iibbAgent" checked={invoiceData.iibbperceptionagent} onChange={(e) => setInvoiceData({ ...invoiceData, iibbperceptionagent : e.checked})} />
                    <label htmlFor="iibbAgent" style={{whiteSpace: "nowrap"}}> Agente de percepción IIBB</label> 
                </div>
                <InputTextCustom
                    className={"white-component"}
                    spanClassName='border2'
                    name="address"
                    value={invoiceData.fiscaladdress ?? ""}
                    onChange={(e) => setInvoiceData({ ...invoiceData, fiscaladdress: e.target.value })}
                    label='Dirección fiscal'
                />
            </div>
            <div className="config-container">
                <fieldset className="afipSection">
                    <h3 className="container-title">ARCA</h3>
                    <div className="flex flex-col md:flex-row items-center">
                        <InputDate
                            label="Inicio de actividades"
                            className="w-full md:w-3"
                            calendarClassName="border2Date"
                            style={{marginRight: '10px'}}
                            placeholder="mm/aaaa"
                            view="month"
                            dateFormat="mm/yy"
                            maxDate={new Date()}
                            value={invoiceData.companystartdate}
                            onChange={(e) => setInvoiceData({ ...invoiceData, companystartdate: e.target.value })}
                        />
                        <InputTextCustom
                            value={invoiceData.afipalias}
                            onChange={(e) => {
                                setProvisoryAfipAlias(e.target.value);
                                if(stepsRef.current.getActiveStep() == 0) {
                                    setInvoiceData({...invoiceData, afipalias: e.target.value});
                                    return;
                                }
                                setOpenResetAfipConnectionModal(true);
                            }}
                            label="Alias"
                            spanClassName="border2"
                            className={'md:w-2 white-component'} 
                        />
                        <div style={{width: '50%', marginTop: '30px'}}>
                        <InputSwitch
                            style={{width: '100%'}}
                            label='Producción'
                            className='ml-2 md:w-3'
                            checked={!!invoiceData.afipproductionmode}
                            onChange={(e) => setInvoiceData({...invoiceData, afipproductionmode:!!e.value})}
                        />
                        </div>
                    </div>
                    <div className='flex flex-column p-2 md:p-4 lg:p-6'>
                        <CustomSteps
                        ref={stepsRef}
                        manualyStepSetting={true}
                        steps={(activeStep) => [
                            {
                            title: 'Paso 1 - Clave privada',
                            icon: 'pi-key',
                            mainBtn: {
                                label: "Generar",
                                className: "btn-ghost",
                                onClick: () => {
                                    if(!invoiceData.fiscalid) {
                                        dispatch(setNotification({
                                            title: "Completa tu N° de documento fiscal",
                                            typeOfNotification: ETypeOfNotification.WARNING
                                        }));
                                        return;
                                    }
                                    if(!invoiceData.afipalias) {
                                        dispatch(setNotification({
                                            title: "Completa tu ALIAS de ARCA",
                                            typeOfNotification: ETypeOfNotification.WARNING
                                        }));
                                        return;
                                    }
                                         
                                    return generateAfipPrivateKey(invoiceData.afipalias, invoiceData.fiscalid, invoiceData.afipproductionmode, invoiceData.iibbperceptionagent).then((response) => {
                                        if(!response) {
                                            dispatch(setNotification({
                                                title: "Hemos tenido un error para generar tu clave privada",
                                                icon: 'pi-times',
                                                typeOfNotification: ETypeOfNotification.ERROR
                                            }));                                            
                                            return;
                                        }
                                        stepsRef.current.nextStep();
                                    });
                                }

                            },
                            description: <p className='text-bluegray-500'> Vamos a generar una clave privada para conectarte con ARCA</p>,
                            buttonResult: activeStep == 0 ? '' : <span className='primary ml-3 mr-2'>Clave Generada <i className='pi pi-check border-circle shadow-1 p-1' /></span>
                            },
                            {
                                title: 'Paso 2 - Archivo CSR',
                                icon: 'pi-paperclip',
                                mainBtn: {
                                    label: "Generar",
                                    className: "btn-ghost",
                                    onClick: () => {
                                        return generateCSRCertificate().then((response) => {
                                            if(!response) {
                                                dispatch(setNotification({
                                                    title: "Hemos tenido un error para generar el archivo CSR",
                                                    icon: 'pi-times',
                                                    typeOfNotification: ETypeOfNotification.ERROR
                                                }));
                                                return;
                                            }
                                            stepsRef.current.nextStep();
                                            navigator.clipboard.writeText(response).then(() => {
                                                dispatch(setNotification({
                                                    title: "Tu CSR fue copiado al portapapeles",
                                                    icon: 'pi-check',
                                                    typeOfNotification: ETypeOfNotification.INFO
                                                }));
                                            });
                                        });
                                    }
                                },
                                description: <p className='text-bluegray-500'> Vamos a generar y copiar en tu portapapeles, el contenido del archivo CSR.<br /> Después dirigite a la página de ARCA donde tendrás que cargarlo para generar el certificado</p>
                            },
                            {
                            title: 'Paso 3 - Pegar texto de Certificado de ARCA',
                            icon: 'pi-save',
                            mainBtn: {
                                label: "Guardar",
                                className: "btn-ghost",
                                onClick: () => {
                                    if(!dfCertificateDue) {
                                        dispatch(setNotification({
                                            title: "Completa el vencimiento del certificado",
                                            typeOfNotification: ETypeOfNotification.WARNING
                                        }));
                                        return;
                                    }
                                    if(!afipCertificate) {
                                        dispatch(setNotification({
                                            title: "Ingresa el certificado de ARCA en el area de texto",
                                            typeOfNotification: ETypeOfNotification.WARNING
                                        }));
                                        return;
                                    }
                                         
                                    return saveAfipCertificate(dfCertificateDue, afipCertificate).then((response) => {
                                        if(!response) {
                                            dispatch(setNotification({
                                                title: "Hemos tenido un error para guardar tu certificado de ARCA",
                                                icon: 'pi-times',
                                                typeOfNotification: ETypeOfNotification.ERROR
                                            }));
                                            return;
                                        }
                                        stepsRef.current.nextStep();
                                    });
                                }
                            },
                            description: (
                                <div className='flex flex-col' style={{width: '50%'}}>
                                <p className='text-bluegray-500 mb-4'>En este campo vamos a pegar el texto del certificado que te provee ARCA. Si existe un texto anterior, por favor borralo.</p>
                                <InputDate
                                    className="w-full md:w-6"
                                    calendarClassName="border2Date"
                                    label="Vencimiento de certificado"
                                    placeholder="dd/mm/aaaa"
                                    minDate={new Date(new Date().setDate(new Date().getDate() + 1))}
                                    value={dfCertificateDue}
                                    onChange={(e) => setDfCertificateDue(e.target.value)}
                                    disable={activeStep != 2}
                                />
                                <TextArea
                                    disable={activeStep != 2}
                                    className="w-full"
                                    value={afipCertificate}
                                    onChange={(e) => setAfipCertificate(e.target.value)}
                                />
                                </div>
                            )
                            },
                            {
                            title: 'Paso 4 - Conexión con ARCA',
                            icon: 'pi-share-alt',
                            mainBtn: {
                                label: "Probar",
                                className: "btn-ghost",
                                onClick: () => {
                                    if(!invoiceData.fiscalid) {
                                        dispatch(setNotification({
                                            title: "Completa tu N° de documento fiscal",
                                            typeOfNotification: ETypeOfNotification.WARNING
                                        }));
                                        return;
                                    }
                                    if(!invoiceData.afipalias) {
                                        dispatch(setNotification({
                                            title: "Completa tu ALIAS de ARCA",
                                            typeOfNotification: ETypeOfNotification.WARNING
                                        }));
                                        return;
                                    }

                                    setIsAfipConnectionTestingLoading(true);

                                    return testAfipConnection(invoiceData.afipproductionmode ?? false).then((response) => {

                                        setIsAfipConnectionTestingLoading(false);

                                        if(!response.success) {
                                            setIsAfipConnectionSuccessful(false);
                                            dispatch(setNotification({
                                                title: response.errormessage,
                                                icon: 'pi-times',
                                                typeOfNotification: ETypeOfNotification.ERROR
                                            }));
                                            return;
                                        }
                                        setIsAfipConnectionSuccessful(true);
                                        stepsRef.current.nextStep();
                                        dispatch(setNotification({
                                            title: 'La conexión con ARCA ha sido exitosa',
                                            icon: 'pi-check',
                                            typeOfNotification: ETypeOfNotification.INFO
                                        }));

                                    });   
                                }
                            },
                            description: 'Probaremos si la conexión con ARCA es válida.',
                            lastStep: true,
                            buttonResult:<React.Fragment>
                                {isAfipConnectionSuccessful !== null ? <span className='primary ml-3'>Test {isAfipConnectionSuccessful ? 'exitoso' : 'fallido'}</span> : <></>}
                                <i className={classNames('pi primary border-circle shadow-1 p-1 ml-2', {
                                'hidden': !isAfipConnectionTestingLoading && isAfipConnectionSuccessful === null,
                                'pi-check': !isAfipConnectionTestingLoading && isAfipConnectionSuccessful,
                                'pi-times': !isAfipConnectionTestingLoading && !isAfipConnectionSuccessful,
                                'pi-spin pi-spinner': isAfipConnectionTestingLoading
                                })} />
                            </React.Fragment>
                            }
                        ]}
                        />
                    </div>
                </fieldset>
            </div>
            <div className="config-container">
                <fieldset className="payment-section">
                    <div className="grid-row two-columns">
                        <h3 className="container-title" style={{height: '50%', marginBottom: '0px', marginTop: '10px'}}>Cuentas De Pago</h3>
                        <button className="secondaryBtn" onClick={() => {
                            // Abrir el modal para agregar una nueva cuenta de pago
                            setSelectedPaymentAccount(defaultPaymentAccount);
                            setEditPaymentAccount(false);
                            setOpenPaymentAccountModal(true);
                        }} >
                            Agregar
                        </button>
                    </div>          
                    {invoiceData.paymentaccounts?.map((account, index) => (
                        <div key={index} className="payment-account-item" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', borderBottom: '1px solid #A9B1BC', padding: '10px 0' }}>
                            <div>
                                <strong>{account.paymentMethod?.name}</strong>
                                <p>{account.accountId} - {account.description}</p>
                            </div>
                            <div style={{ display: 'flex', gap: '10px' }}>
                                <button 
                                    style={{ background: 'none', border: 'none', color: '#3CB8BA', fontWeight: 600 }} 
                                    onClick={() => {
                                        setSelectedPaymentAccount(account);
                                        setEditPaymentAccount(true);
                                        setOpenPaymentAccountModal(true);
                                    }}
                                >
                                    <Icon icon="bi:pencil" style={{ fontSize: '20px' }} />
                                </button>

                                <button 
                                    style={{ background: 'none', border: 'none', color: '#3CB8BA', fontWeight: 600 }} 
                                    onClick={() => handleDeletePaymentAccount(account)}
                                >
                                    <Icon icon="bi:x" style={{ fontSize: '20px' }} />
                                </button>
                            </div>
                        </div>
                    ))}             
                </fieldset>
            </div>
            <div className="config-container">
                <fieldset className="data-section">
                    <h3 className="container-title">Datos Receptor - Valores Por Defecto</h3>
                    <div className="grid-row four-columns">
                        <Combobox 
                            label='Tipo de factura' 
                            placeholder='Seleccionar' 
                            autocompleteClassName="combobox-border" 
                            getItems={getAllAdministrativeFormTypes}
                            value={invoiceData.invoicetype?.name}
                            setValue={(administrativeFormTypes: any) => setInvoiceData({ ...invoiceData, invoicetype : {id : administrativeFormTypes.administrativeformtypei18n, name : administrativeFormTypes.description} })}
                            optionLabel="shortdescription"
                        />
                        <Combobox 
                            label='Punto de venta' 
                            placeholder='Seleccionar' 
                            autocompleteClassName="combobox-border" 
                            getItems={loadAllPOS}
                            params={{adminformtype: invoiceData.invoicetype?.id}}
                            value={invoiceData.pos?.name}
                            setValue={(pos: ComboDataDTO) => setInvoiceData({ ...invoiceData, pos : pos })}
                            optionLabel="name"
                        />
                        <Combobox 
                            label='Medio de pago' 
                            placeholder='Seleccionar' 
                            autocompleteClassName="combobox-border"   
                            getItems={getPaymentMethods}
                            optionLabel='methodName'
                            value={invoiceData.paymentmethod?.name}
                            setValue={(paymentMethod: any) => setInvoiceData({ ...invoiceData, paymentmethod : {id: paymentMethod.paymentMethod, name: paymentMethod.methodName} })}
                        />
                        <InputTextCustom
                            className="white-component"
                            spanClassName="border2"
                            name="bankAccount"
                            value={invoiceData.bankaccount ?? ''}
                            onChange={(e) => setInvoiceData({ ...invoiceData, bankaccount : e.target.value})}
                            label="Cuenta bancaria"
                        />
                    </div>
                </fieldset>
            </div>
        </div>

       <PaymentAccountModal 
            openPaymentAccountModalModal={openPaymentAccountModal} 
            setOpenPaymentAccountModalModal={setOpenPaymentAccountModal} 
            isEdditing={editPaymentAccount} 
            paymentAccount={selectedPaymentAccount} 
            onClose={() => {setOpenPaymentAccountModal(false)}} 
            onSave={(paymentAccount:PaymentAccount) => {
                handleAddOrEditionPaymentAccount(editPaymentAccount, paymentAccount);
                setOpenPaymentAccountModal(false);
            }} 
        />
        <ResetAfipConnectionModal openResetAfipConnectionModal={openResetAfipConnectionModal} setOpenResetAfipConnectionModal={setOpenResetAfipConnectionModal} doReset={
            (doReset:boolean) => {
                if(!doReset) {
                    setOpenResetAfipConnectionModal(false);
                    return;
                }

                setInvoiceData({...invoiceData, afipalias: provisoryAfipAlias,fiscalid:provisoryFiscalId});
                stepsRef.current.setActiveStep(0);
                setOpenResetAfipConnectionModal(false);
            }
        }/>
    </React.Fragment>
}